// extracted by mini-css-extract-plugin
module.exports = {"root":"perguntas-frequentes_root__2RvH3","page":"perguntas-frequentes_page__1h8fe","title":"perguntas-frequentes_title__1r8QQ","content":"perguntas-frequentes_content__1Qlb-"};